{
  "id": "campaign-139",
  "name": "Untamed Bowl",
  "seed": "campaign:139",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r,,,,,QQQQ,,,~,r",
    ",,,:,,,,,,,,:~~,",
    ",,,:,,a,,a,,:~,,",
    ",,#::::::::::x,,",
    ",,,,,,,,,,,,,,,,",
    "~a,~a,a,,a,a,,a,",
    "~~~,,,,,,,,,,,,,",
    "~..,,,,,,...,,,,",
    "...,,,a,,a..,#,,",
    "::::::::::::::::",
    ".,,,a,,,,,,a...,",
    ",,,,,,,,,,,.....",
    ",,,,,,a,,a,.....",
    ",,,,x,,,,,,.....",
    ",,,::::::::::..,",
    ",a,:a,,,,,.a:,a,",
    "..,:,,,,,,..:,..",
    "S...,,QQQQ......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 14,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 13,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 17
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 15,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 12,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 15,
      "y": 12
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 9
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 11
  },
  "generatorVersion": 3,
  "level": 139,
  "biome": "stadium",
  "par": {
    "reel": 11076,
    "push": 9472,
    "selfPropelled": 8694,
    "tractor": 7093,
    "zeroTurn": 6166,
    "fairway": 3759
  },
  "goldTime": {
    "reel": 10889,
    "push": 9329,
    "selfPropelled": 8643,
    "tractor": 7046,
    "zeroTurn": 6080,
    "fairway": 3759
  },
  "routeTries": {
    "par": {
      "reel": 23,
      "push": 2,
      "selfPropelled": 16,
      "tractor": 12,
      "zeroTurn": 7,
      "fairway": 15
    },
    "gold": {
      "reel": 26,
      "push": 25,
      "selfPropelled": 35,
      "tractor": 33,
      "zeroTurn": 25,
      "fairway": 15
    }
  }
}
